const UUID_V4_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function byteToHex(byte) {
  return byte.toString(16).padStart(2, "0");
}

export function createAttachmentUploadRequestId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);

  if (
    typeof crypto !== "undefined" &&
    typeof crypto.getRandomValues === "function"
  ) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, byteToHex).join("");
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join("-");
}

export function isValidAttachmentUploadRequestId(value) {
  return UUID_V4_RE.test(String(value || "").trim());
}

export function buildAttachmentUploadPath(roId, uploadRequestId) {
  const base = `/api/attachments/ro/${encodeURIComponent(String(roId || ""))}`;
  const cleanId = String(uploadRequestId || "").trim();
  if (!cleanId) return base;
  return `${base}?uploadRequestId=${encodeURIComponent(cleanId)}`;
}

export function isRetryableAttachmentUploadError(error) {
  const status = Number(error?.status || 0);
  if (!status) return true;
  if (status === 408 || status === 425 || status === 429) return true;
  return status >= 500;
}
